<template>
  <div :id="id" :class="className" ref="echarts" :style="{ height: height, width: width }" />
</template>

<script>
const echarts = require("echarts");

export default {
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "pie-chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    option: {
      type: Object,
      default:{
        tooltip: {
            trigger: 'axis', //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
            backgroundColor: 'rgba(0, 10, 26, 0.8)',
            borderRadius: 8,  
            borderWidth: 0,
            shadowColor:'rgba(13, 148, 255, 0.8)',
            axisPointer: {// 坐标轴指示器，坐标轴触发有效
              type: 'line', // 默认为直线，可选为：'line' | 'shadow'
            },
            textStyle: {
                color: '#fff'
            },
          },
      }
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    let myChart = echarts.init(this.$refs.echarts);
			this.myChart = myChart
      // let  option= {
      //   tooltip: {
      //       trigger: 'axis', //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
      //       backgroundColor: 'rgba(0, 10, 26, 0.8)',
      //       borderRadius: 8,  
      //       borderWidth: 0,
      //       shadowColor:'rgba(13, 148, 255, 0.8)',
      //       axisPointer: {// 坐标轴指示器，坐标轴触发有效
      //         type: 'line', // 默认为直线，可选为：'line' | 'shadow'
      //       },
      //         textStyle: {
      //             color: '#fff'
      //         },
      //     }
      // }
			this.myChart.setOption(this.option,true);

			window.addEventListener("resize", () => {
				this.myChart.resize();
			});
  },
  // beforeDestroy() {
  //   if (!this.myChart) {
  //     return;
  //   }
  //   this.myChart.dispose();
  //   this.myChart = null;
  // },
  methods: {
    
  },
  watch: {
    option: function(newData, oldData) {
      this.myChart.clear()
			this.myChart.setOption(newData,true);
    },
  },
};
</script>
